<template>
  <b-card class="dashboard-card" text-variant="white">
    <slot></slot>
  </b-card>
</template>

<script>
import config from '@/plugins/config';

export default {
  name: 'DashboardCard',
  data() {
    return {
      randomPercentage: null
    }
  },
  created() {
    // Generate a random percentage between -15 and +5
    this.randomPercentage = Math.random() * 30 - 25; // Range: -15 to +5
  },
  computed: {
    cardBgColor() {
      const baseColor = config.theme.menuBackgroundColor;
      return this.adjustColorByPercentage(baseColor, this.randomPercentage);
    }
  },
  methods: {
    adjustColorByPercentage(hex, percentage) {
      // Convert hex to RGB
      const r = parseInt(hex.slice(1, 3), 16);
      const g = parseInt(hex.slice(3, 5), 16);
      const b = parseInt(hex.slice(5, 7), 16);

      let adjustedR, adjustedG, adjustedB;

      if (percentage > 0) {
        // Make lighter by blending with white
        const factor = percentage / 100;
        adjustedR = Math.min(255, Math.round(r + (255 - r) * factor));
        adjustedG = Math.min(255, Math.round(g + (255 - g) * factor));
        adjustedB = Math.min(255, Math.round(b + (255 - b) * factor));
      } else {
        // Make darker by reducing brightness
        const factor = 1 + (percentage / 100);
        adjustedR = Math.max(0, Math.round(r * factor));
        adjustedG = Math.max(0, Math.round(g * factor));
        adjustedB = Math.max(0, Math.round(b * factor));
      }

      return `#${adjustedR.toString(16).padStart(2, '0')}${adjustedG.toString(16).padStart(2, '0')}${adjustedB.toString(16).padStart(2, '0')}`;
    }
  }
}
</script>

<style scoped>
.dashboard-card {
  background-color: v-bind(cardBgColor);
}
</style>
